// extracted by mini-css-extract-plugin
export default {"box":"box-C_CwF","header":"header-nMFeH","level":"level-DXbMP","hovered":"hovered-ZCVCT"};